const prerender = true;
const trailingSlash = "always";
export {
  prerender,
  trailingSlash
};
